import React from 'react'
import servicesTwoData from './servicesTwoData'

const ServicesTwo = () => {
    return (
        <section className="our-service-wrapper section-padding bg-gray">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="block-contents text-center">
                            <div className="section-title">
                                <h5>Service</h5>
                                <span>Our Services</span>
                                <h2>DETAILED SERVICES</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3">
                    {
                        servicesTwoData.map((data) => (
                            <div className="col-xl-4 col-md-6 col-12 d-flex" key={data.id}>
                                <div className="ac-service-card w-100">
                                    <div className="ac-service-img-wrap">
                                        <img src={data.img} alt={data.title} className="ac-service-img" loading="lazy" width="400" height="260" />
                                    </div>
                                    <div className="ac-service-content">
                                        <h4 className="ac-service-title">{data.title}</h4>
                                        <p className="ac-service-desc">{data.desc}</p>
                                        <a
                                            href="https://wa.me/971502033924"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="theme-btn ac-service-btn"
                                        >
                                            {data.cta}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </section>
    )
}

export default ServicesTwo